import { Component } from '@angular/core';

@Component({
	templateUrl: '../../../../../assets/svg/edit.svg',
})
export class EditComponent {}
